import React from 'react';
import './login.css'
import Loginform from '../../Components/Login/LoginForm';

const Loginpage = () => {
    return (
        <>
            <Loginform />
        </>
    );
}

export default Loginpage;